import { render, staticRenderFns } from "./GeneralStep.vue?vue&type=template&id=5c28cbbf&scoped=true"
import script from "./GeneralStep.vue?vue&type=script&lang=ts"
export * from "./GeneralStep.vue?vue&type=script&lang=ts"
import style0 from "./GeneralStep.vue?vue&type=style&index=0&id=5c28cbbf&prod&lang=scss&scoped=true"
import style1 from "./GeneralStep.vue?vue&type=style&index=1&id=5c28cbbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28cbbf",
  null
  
)

export default component.exports